"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaskType = void 0;
exports.instanceOfMaskType = instanceOfMaskType;
exports.MaskTypeFromJSON = MaskTypeFromJSON;
exports.MaskTypeFromJSONTyped = MaskTypeFromJSONTyped;
exports.MaskTypeToJSON = MaskTypeToJSON;
exports.MaskTypeToJSONTyped = MaskTypeToJSONTyped;
/**
 *
 * @export
 */
exports.MaskType = {
    ThreeM1870Plus: 'THREE_M_1870_PLUS',
    ThreeM1860: 'THREE_M_1860',
    ThreeM1860S: 'THREE_M_1860_S',
    Other: 'OTHER'
};
function instanceOfMaskType(value) {
    for (const key in exports.MaskType) {
        if (Object.prototype.hasOwnProperty.call(exports.MaskType, key)) {
            if (exports.MaskType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function MaskTypeFromJSON(json) {
    return MaskTypeFromJSONTyped(json, false);
}
function MaskTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function MaskTypeToJSON(value) {
    return value;
}
function MaskTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=MaskType.js.map